export default __webpack_public_path__ + "967c983b79451d48219efff6b7234369.png";